
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_17427_1ns0c_5"
};
  